// extracted by mini-css-extract-plugin
export var labelWrapper = "_bm-0";